<template>
  <div>
    <b-row>
      <b-col cols="8">
        <div>
          <h2>{{ $t("gasStation.title") }}</h2>
        </div>
        <div>
          <router-link to="././create">
            <b-button size="sm">{{ $t("geral.create") }}</b-button>
          </router-link>
          <b-button
            size="sm"
            class="ml-2 btn-checklist cleanFilters"
            @click="cleanFilters"
          >
            {{ $t("geral.cleanFilters") }}
          </b-button>
          <b-button
            size="sm"
            class="ml-2 btn-checklist cleanFilters"
            @click="$refs.table.refresh()"
          >
            <i
              class="material-icons"
              style="font-size: 18px; vertical-align: middle; margin-right: 5px"
            >
              refresh
            </i>
            {{ $t("geral.refresh") }}
          </b-button>
        </div>
      </b-col>
      <b-col
        cols="4"
        style="display: flex; justify-content: flex-end; align-items: flex-end"
      >
        <base-event-timer
          :timer.sync="eventTimer"
          :lastRefreshTime="lastRefreshTime"
        ></base-event-timer>
        <!-- {{eventTimer}} -->
      </b-col>
    </b-row>

    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div v-if="field.filterKey != 'actions'">
                <b-form-input
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                  class="idStyle"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <router-link :to="`././edit/${data.item.id}`">
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>
          <b-button
            v-if="data.item.active"
            style="margin-left: 5px;"
            size="sm"
            class="btn-checklist ml-2"
            @click="inactivateStation(data.item.id)"
            :disabled="isLoading"
          >
            Desativar
          </b-button>
          <b-button
            v-else
            style="margin-left: 5px;"
            size="sm"
            class="btn-checklist ml-2"
            @click="activateStation(data.item.id)"
            :disabled="isLoading"
          >
            Ativar
          </b-button>
        </template>
      </b-table>
    </b-row>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </div>
</template>
<script>
export default {
  name: "GasStationList",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Posto de gasolina cadastrado com sucesso"
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          thStyle: "width: 100px"
        },
        {
          key: "documentNumber",
          filterKey: "documentNumber",
          label: "CNPJ"
        },
        {
          key: "companyName",
          filterKey: "companyName",
          label: "Razão social"
        },
        {
          key: "fantasyName",
          filterKey: "fantasyName",
          label: "Nome fantasia"
        },
        {
          key: "cityName",
          filterKey: "cityName",
          label: "Cidade"
        }
      ],
      tableFilters: {
        documentNumber: "",
        companyName: "",
        fantasyName: "",
        cityName: ""
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      isLoading: false
    };
  },
  created() {},
  methods: {
    cleanFilters() {
      this.tableFilters = {
        documentNumber: "",
        companyName: "",
        fantasyName: "",
        cityName: ""
      };
    },
    updateTableMethod() {
      this.$refs.table.refresh();
    },
    getUrlEdit(vehicle) {
      return `././edit/${vehicle.id}`;
    },
    downloadLayout() {
      this.$apiVehicle
        .request({
          url: `/vehicle/import/download/`,
          method: "GET",
          responseType: "arraybuffer" //important
        })
        .then(response => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"]
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$refs.openModal.hide();
        });
    },
    myProvider(ctx, callback) {
      console.log("myProvider called");
      this.isBusy = true;
      // console.log(ctx);

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        documentNumber: this.tableFilters.documentNumber,
        companyName: this.tableFilters.companyName,
        fantasyName: this.tableFilters.fantasyName,
        cityName: this.tableFilters.cityName
      };
      this.$apiVehicle
        .post("/gasStation/paginate/", apiParam)
        .then(response => {
          const items = response.data.items;
          // console.log = ("ok")
          // console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch(error => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    inactivateStation(stationId) {
      this.isLoading = true;
      console.log(`Inativando posto de combustível com ID: ${stationId}`);
      this.$apiVehicle
        .post(`/gasStation/deactivate/${stationId}`)
        .then(response => {
          console.log(response.data);
          this.alert.success = "Posto de combustível inativado com sucesso!";
          this.$refs.alert.show();
        })
        .catch(error => {
          console.log(error);
          this.alert.error = error.message;
          this.$refs.danger.show();
        })
        .finally(() => {
          this.isLoading = false;
          this.$refs.table.refresh();
        });
    },
    activateStation(stationId) {
      console.log(`Ativando posto de combustível com ID: ${stationId}`);
      this.isLoading = true;
      this.$apiVehicle
        .post(`/gasStation/activate/${stationId}`)
        .then(response => {
          console.log(response.data);
          this.alert.success = "Posto de combustível ativado com sucesso!";
          this.$refs.alert.show();
        })
        .catch(error => {
          console.log(error);
          this.alert.error = error.message;
          this.$refs.danger.show();
        })
        .finally(() => {
          this.isLoading = false;
          this.$refs.table.refresh();
        });
    }
  }
};
</script>
